var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageTablePanel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 92,
    viewBox: "0 0 234 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 0.5,
    width: 207,
    height: 55,
    rx: 13.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.5,
    y: 0.5,
    width: 207,
    height: 55,
    rx: 13.5,
    stroke: "#1A1A1A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8335,
    y: 13.8333,
    width: 137.667,
    height: 8.77778,
    rx: 3.94444,
    stroke: "#1A1A1A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66.8335,
    y: 31.6111,
    width: 137.667,
    height: 8.77778,
    rx: 3.94444,
    stroke: "#1A1A1A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.4643,
    y: 15.4643,
    width: 25.0714,
    height: 25.0714,
    rx: 7.89286,
    fill: "#DBF5B3",
    stroke: "#1A1A1A",
    strokeWidth: 0.928571
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5,
    width: 233,
    height: 62,
    rx: 13.5,
    fill: "#DBF5B3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 29.5,
    width: 233,
    height: 62,
    rx: 13.5,
    stroke: "#1A1A1A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 44.5,
    width: 155,
    height: 10,
    rx: 4.5,
    fill: "white",
    stroke: "#1A1A1A"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 64.5,
    width: 155,
    height: 10,
    rx: 4.5,
    fill: "white",
    stroke: "#1A1A1A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11904_66164)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 46,
    width: 28,
    height: 28,
    rx: 9,
    fill: "#A9E079"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 46.5,
    width: 27,
    height: 27,
    rx: 8.5,
    stroke: "#1A1A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11904_66164",
    x: 17,
    y: 46,
    width: 28,
    height: 30.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 0 0.0980392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11904_66164"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11904_66164",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageTablePanel);
export default __webpack_public_path__ + "static/media/message-table-panel.24fb4fa2347348118ee51056ac06eabc.svg";
export { ForwardRef as ReactComponent };